import { defineNuxtPlugin } from '#imports';
import { ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from 'E:/TyApp/node_modules/element-plus/es/index.mjs';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp
    .provide(ID_INJECTION_KEY, {"prefix":1024,"current":0})
    .provide(ZINDEX_INJECTION_KEY, {"current":0});
})
